
export { CollectionName } from "/codebuild/output/src3708900472/src/packages/search-document-builders/src/registry/collection-registry.ts"
export { collectionAlias } from "./registry/schema-registry"